import axios from 'axios';
import consts from '@/static/js/consts';

export default {

  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(consts.ENDPOINTS.USER)
        .then((response) => {
          commit('setProfile', response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateProfile({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.patch(consts.ENDPOINTS.USER, payload)
        .then((response) => {
          commit('updateProfile', payload);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

};
